import {useTranslation} from '@aboutyou/i18n';
import {useHistory} from '@aboutyou/router';
import {EmptyState, GenericIconName} from '@aboutyou/ui-components';
import React from 'react';
import {useSelectedDiscount} from '../../backend-services/Campaigns/SelectedDiscounts/useSelectedDiscount';
import {IconWrapper, StyledButton, StyledHeading} from './ProductStreamEmpty';

export const ProductStreamEmptyDeals = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const selectedDiscount = useSelectedDiscount();
  return (
    <EmptyState
      data-testid="ProductStreamEmptyDealTab"
      asset={<IconWrapper asset={GenericIconName.EmptySearch} />}
      title={
        <StyledHeading as="h1">
          {t('We are sorry, no Deals are available!')}
        </StyledHeading>
      }
      subtitle={t(
        'There are no search results available for the category and filter selection, you have chosen.',
      )}
      cta={
        <StyledButton
          variant="secondary"
          onClick={() => {
            if (selectedDiscount?.linkTarget) {
              history.push(selectedDiscount.linkTarget.url);
            }
          }}
        >
          {t('All deal items')}
        </StyledButton>
      }
    />
  );
};
